const sx = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    py: { xs: 8, md: 12 },
    px: 2,
    minHeight: '70vh',
  },
  mainTitle: {
    color: '#3FA9F5',
    fontWeight: 800,
    fontSize: { xs: '2rem', md: '2.5rem' },
    textTransform: 'uppercase',
    textAlign: 'center',
    mb: 1,
  },
  subtitle: {
    color: '#122549',
    fontSize: { xs: '1.2rem', md: '1.5rem' },
    textAlign: 'center',
    fontWeight: 500,
    mb: 6,
    maxWidth: 600,
  },
  card: {
    border: '2px solid #122549',
    borderRadius: '12px',
    p: { xs: 3, md: 5 },
    maxWidth: 600,
    width: '100%',
    backgroundColor: 'white',
  },
  sectionTitle: {
    color: '#3FA9F5',
    fontWeight: 700,
    fontSize: '1.2rem',
    mb: 3,
    textTransform: 'uppercase',
  },
  infoRow: {
    display: 'flex',
    alignItems: 'center',
    mb: 2,
    color: '#122549',
  },
  icon: {
    color: '#3FA9F5',
    mr: 1.5,
  },
  stepRow: {
    display: 'flex',
    alignItems: 'center',
    mb: 2,
    color: '#122549',
  },
  stepCircle: {
    minWidth: 28,
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: '#3FA9F5',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: '0.9rem',
    mr: 2,
  },
  footerText: {
    textAlign: 'center',
    color: '#122549',
    fontSize: '0.85rem',
    mt: 4,
  },
}

export default sx
